module.exports = __webpack_public_path__ + "img/ក្ដាម.83ca1eff.png";